import React from 'react';
import PropTypes from 'prop-types';
import { DataSet } from './DataSet';

export const DataSetCollection = ({
  dataSetHeight,
  ChartTooltip,
  ChartLegend,
  collection,
  showAxisLine,
}) => {
  if (typeof dataSetHeight !== 'number' || dataSetHeight <= 0) {
    throw new Error(`Developer configuration error: dataSetHeight must be a positive number. got:${dataSetHeight}`);
  }

  if (!collection) {
    throw new Error('Developer configuration error: Must be guaranteed a collection');
  }

  const resources = React.useMemo(() => collection.resources().list(), [collection]);

  return resources.map((resource) => {
    return (
      <DataSet
        height={dataSetHeight}
        key={resource.id()}
        dataSetResource={resource}
        ChartTooltip={ChartTooltip}
        ChartLegend={ChartLegend}
        showAxisLine={showAxisLine}
      />
    );
  });
};

DataSetCollection.defaultProps = {
  onClick: undefined,
  ChartTooltip: undefined,
  ChartLegend: undefined,
};

DataSetCollection.propTypes = {
  dataSetHeight: PropTypes.number.isRequired,
  collection: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  ChartTooltip: PropTypes.func,
  ChartLegend: PropTypes.func,
};
